module.exports = __webpack_public_path__ + "img/wendu.e11c8084.png";